var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95398 2.62395L2.80398 5.45662M6.54198 9.19595L9.37598 10.0459M5.78865 6.21128L9.62798 2.37195",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 2.66663C2.21891 2.66663 2.66663 2.21891 2.66663 1.66663C2.66663 1.11434 2.21891 0.666626 1.66663 0.666626C1.11434 0.666626 0.666626 1.11434 0.666626 1.66663C0.666626 2.21891 1.11434 2.66663 1.66663 2.66663Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 2.66663C10.8855 2.66663 11.3333 2.21891 11.3333 1.66663C11.3333 1.11434 10.8855 0.666626 10.3333 0.666626C9.78097 0.666626 9.33325 1.11434 9.33325 1.66663C9.33325 2.21891 9.78097 2.66663 10.3333 2.66663Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 11.3333C10.8855 11.3333 11.3333 10.8855 11.3333 10.3333C11.3333 9.78097 10.8855 9.33325 10.3333 9.33325C9.78097 9.33325 9.33325 9.78097 9.33325 10.3333C9.33325 10.8855 9.78097 11.3333 10.3333 11.3333Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 11.3333C5.32348 11.3333 6.66663 9.99011 6.66663 8.33325C6.66663 6.6764 5.32348 5.33325 3.66663 5.33325C2.00977 5.33325 0.666626 6.6764 0.666626 8.33325C0.666626 9.99011 2.00977 11.3333 3.66663 11.3333Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerManagement);
export default __webpack_public_path__ + "static/media/partnerManagement.1be40a8c8b07a2260ee92f88857cf4f7.svg";
export { ForwardRef as ReactComponent };